<script setup>
import {useRoute, useRouter} from "vue-router";
import {ref} from "vue";
import {definePage} from "unplugin-vue-router/runtime";

definePage({
  meta: {
    name: 'taak-bewerken',
    title: 'Taak bewerken - info',
    requiresAuth: true,
    admin: true,
    layout: 'admin-task',
  },
})

const route = useRoute();
const router = useRouter();

const taskId = parseInt(route.params.id);

const stepperRef = ref(null);

const currentStep = ref(null);
const setCurrentStep = (step) => {
  currentStep.value = step;
}

const prev = async () => {
  if (currentStep.value === null || currentStep.value === 1) {
    await router.push('/admin')
  }
  else {
    stepperRef.value?.setStep(currentStep.value - 1);
  }
}

</script>
<template>
  <task-header title="Taak bewerken" @click="prev()"/>

  <task-stepper
    ref="stepperRef"
    :task-id="taskId"
    @update="setCurrentStep"
  />
</template>
